import type { AppTheme } from '@/shared/constant/AppTheme';
import { DebugPanelSize, type ScreenSize } from '@/shared/constant/ScreenSize';
import { createContextStore } from '@/shared/util/createContextStore';

export type AppearanceConfigState = {
  isOpenDebugPanel: boolean;
  screenSize: ScreenSize | undefined;
  debugPanelSize: number;
  appTheme: AppTheme.Dark | AppTheme.Light | undefined;
  progressBarLoading: boolean;
};

export type AppearanceConfigAction = {
  setIsOpenDebugPanel: (isOpen: boolean) => void;
  getState: () => AppearanceConfigState;
  setScreenSize: (screenSize: ScreenSize | undefined) => void;
  setDebugPanelSize: (size: number) => void;
  setAppTheme: (theme: AppTheme.Dark | AppTheme.Light) => void;
  setProgressBarLoading: (loading: boolean) => void;
};

export const appearanceConfigInitialState: AppearanceConfigState = {
  isOpenDebugPanel: false,
  screenSize: undefined,
  debugPanelSize: DebugPanelSize.defaultSize,
  appTheme: undefined,
  progressBarLoading: false,
};

const [AppearanceConfigModelStoreProvider, useAppearanceConfigModelStore] = createContextStore<
  AppearanceConfigState,
  AppearanceConfigAction
>((set, get) => ({
  ...appearanceConfigInitialState,
  setIsOpenDebugPanel: (isOpen: boolean) => {
    set((state) => ({
      ...state,
      isOpenDebugPanel: isOpen,
      debugPanelSize: DebugPanelSize.defaultSize,
    }));
  },
  getState: () => {
    return get();
  },
  setScreenSize: (screenSize) => {
    set((state) => ({ ...state, screenSize }));
  },
  setDebugPanelSize: (size) => {
    set((state) => ({ ...state, debugPanelSize: size }));
  },
  setAppTheme: (theme) => {
    set((state) => ({ ...state, appTheme: theme }));
  },
  setProgressBarLoading: (loading) => {
    set((state) => ({ ...state, progressBarLoading: loading }));
  },
}));

export { AppearanceConfigModelStoreProvider, useAppearanceConfigModelStore };
